<h1 mat-dialog-title>Aus- oder Umstallen</h1>
<div mat-dialog-content>
    <div class="one-column">
        <button mat-stroked-button color="accent" (click)="ausstallen()" style="margin-top: 12px; width: 100%"
            >Ausstallen</button
        >
        <button mat-stroked-button color="accent" (click)="umstallen()" style="margin-top: 12px; width: 100%"
            >Umstallen</button
        >
    </div>
</div>
<div mat-dialog-actions align="end">
    <button (click)="cancel()" mat-button>Abbrechen</button>
</div>
